var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M5.333 16h21.333M5.333 16l8-8M5.333 16l8 8"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-camera",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M16 21.333c2.209 0 4-1.791 4-4s-1.791-4-4-4c-2.209 0-4 1.791-4 4s1.791 4 4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M4 12c0-1.473 1.194-2.667 2.667-2.667h3.333c0.736 0 1.333-0.597 1.333-1.333s0.597-1.333 1.333-1.333h6.667c0.736 0 1.333 0.597 1.333 1.333s0.597 1.333 1.333 1.333h3.333c1.473 0 2.667 1.194 2.667 2.667v10.667c0 1.473-1.194 2.667-2.667 2.667h-18.667c-1.473 0-2.667-1.194-2.667-2.667v-10.667z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M26.667 9.333l-14.667 14.667-6.667-6.667"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check-round",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M22.667 12l-9.333 9.333-4-4M10.667 26.667h10.667c2.945 0 5.333-2.388 5.333-5.333v-10.667c0-2.946-2.388-5.333-5.333-5.333h-10.667c-2.946 0-5.333 2.388-5.333 5.333v10.667c0 2.945 2.388 5.333 5.333 5.333z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M5.333 12l10.667 10.667 10.667-10.667"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-up",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M26.667 20l-10.667-10.667-10.667 10.667"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-clock",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.92,
    d: "M16.33 9.6v6.4l3.84 3.84M27.85 16c0 6.362-5.158 11.52-11.52 11.52s-11.52-5.158-11.52-11.52c0-6.362 5.158-11.52 11.52-11.52s11.52 5.158 11.52 11.52z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross-small",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M25.333 6.667l-18.667 18.667M6.667 6.667l18.667 18.667"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54adff",
    style: {
      fill: "var(--color1, #54adff)"
    },
    d: "M6.667 20.941l-0.707-0.707c-0.188 0.187-0.293 0.442-0.293 0.707h1zM20.941 6.667l0.707-0.707c-0.391-0.391-1.024-0.391-1.414 0l0.707 0.707zM25.333 11.059l0.707 0.707c0.391-0.391 0.391-1.024 0-1.414l-0.707 0.707zM11.059 25.333v1c0.265 0 0.52-0.105 0.707-0.293l-0.707-0.707zM6.667 25.333h-1c0 0.552 0.448 1 1 1v-1zM15.451 24.333c-0.552 0-1 0.448-1 1s0.448 1 1 1v-2zM24.784 26.333c0.552 0 1-0.448 1-1s-0.448-1-1-1v2zM7.374 21.648l14.274-14.274-1.414-1.414-14.275 14.275 1.414 1.414zM20.234 7.374l4.392 4.392 1.414-1.414-4.392-4.392-1.414 1.414zM24.626 10.352l-14.275 14.275 1.414 1.414 14.274-14.274-1.414-1.414zM11.059 24.333h-4.392v2h4.392v-2zM7.667 25.333v-4.392h-2v4.392h2zM16.94 10.668l4.392 4.392 1.414-1.414-4.392-4.392-1.414 1.414zM15.451 26.333h9.333v-2h-9.333v2z"
  })), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-closed",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M13.019 7.060c0.936-0.251 1.931-0.394 2.981-0.394 8.485 0 13.333 9.333 13.333 9.333s-1.105 2.128-3.184 4.351M5.799 11.704c-2.045 2.203-3.132 4.296-3.132 4.296s4.848 9.333 13.333 9.333c1.069 0 2.081-0.148 3.033-0.407M15.333 19.945c-1.446-0.243-2.628-1.26-3.106-2.611M16.667 12.055c1.675 0.281 2.997 1.603 3.278 3.278M4 4l24 24"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-open",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M2.667 16c0 0 4.848-9.333 13.333-9.333s13.333 9.333 13.333 9.333-4.849 9.333-13.333 9.333c-8.485 0-13.333-9.333-13.333-9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M16 20c2.209 0 4-1.791 4-4s-1.791-4-4-4c-2.209 0-4 1.791-4 4s1.791 4 4 4z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-female",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.92,
    d: "M16.33 17.28c3.535 0 6.4-2.865 6.4-6.4s-2.865-6.4-6.4-6.4c-3.535 0-6.4 2.865-6.4 6.4s2.865 6.4 6.4 6.4zM16.33 17.28v10.24M12.49 23.68h7.68"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filters-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M18.667 6.667c0-1.473-1.194-2.667-2.667-2.667s-2.667 1.194-2.667 2.667M18.667 6.667c0 1.473-1.194 2.667-2.667 2.667s-2.667-1.194-2.667-2.667M18.667 6.667h8M13.333 6.667h-8M21.333 16c0 1.473 1.194 2.667 2.667 2.667s2.667-1.194 2.667-2.667c0-1.473-1.194-2.667-2.667-2.667s-2.667 1.194-2.667 2.667zM21.333 16h-16M10.667 25.333c0-1.473-1.194-2.667-2.667-2.667s-2.667 1.194-2.667 2.667c0 1.473 1.194 2.667 2.667 2.667s2.667-1.194 2.667-2.667zM10.667 25.333h16"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filters-3",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.92,
    d: "M6.090 5.76l6.4 10.24v7.68l7.68 3.84v-11.52l6.4-10.24h-20.48z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M5.775 16.063l10.225 10.603 10.225-10.603c1.137-1.179 1.775-2.777 1.775-4.444 0-3.471-2.714-6.285-6.061-6.285-1.607 0-3.149 0.662-4.286 1.841l-1.653 1.715-1.653-1.715c-1.137-1.179-2.678-1.841-4.286-1.841-3.347 0-6.061 2.814-6.061 6.285 0 1.667 0.639 3.266 1.775 4.444z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54ADFF",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M5.775 16.063l10.225 10.603 10.225-10.603c1.137-1.179 1.775-2.777 1.775-4.444 0-3.471-2.714-6.285-6.061-6.285-1.607 0-3.149 0.662-4.286 1.841l-1.653 1.715-1.653-1.715c-1.137-1.179-2.678-1.841-4.286-1.841-3.347 0-6.061 2.814-6.061 6.285 0 1.667 0.639 3.266 1.775 4.444z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location-1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.92,
    d: "M26.57 14.72c0 5.655-4.585 10.24-10.24 12.8-5.655-2.56-10.24-7.145-10.24-12.8s4.585-10.24 10.24-10.24c5.655 0 10.24 4.585 10.24 10.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.92,
    d: "M20.17 14.72c0 2.121-1.719 3.84-3.84 3.84s-3.84-1.719-3.84-3.84c0-2.121 1.719-3.84 3.84-3.84s3.84 1.719 3.84 3.84z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M18.667 5.333h5.333c1.473 0 2.667 1.194 2.667 2.667v16c0 1.473-1.194 2.667-2.667 2.667h-5.333M4 16h16M4 16l5.333-5.333M4 16l5.333 5.333"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-male",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.92,
    d: "M16.33 14.72c-3.535 0-6.4 2.865-6.4 6.4s2.865 6.4 6.4 6.4c3.535 0 6.4-2.865 6.4-6.4s-2.865-6.4-6.4-6.4zM16.33 14.72v-10.24M16.33 4.48l5.12 5.12M16.33 4.48l-5.12 5.12"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-hamburger",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M5.333 9.333h21.333M5.333 16h21.333M5.333 22.667h21.333"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pawprint-1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F9",
    style: {
      fill: "var(--color1, #FEF9F9)"
    },
    d: "M20.482 19.149c-0.356-2.644-2.011-4.897-4.429-6.024s-5.208-0.948-7.462 0.479l-5.432 3.439c-0.901 0.571-1.58 1.399-1.964 2.394s-0.436 2.065-0.15 3.093c0.286 1.028 0.882 1.918 1.725 2.573s1.852 1.014 2.919 1.037l0.070 0.001c2.676 0.079 5.219 1.275 6.986 3.289 0.456 0.519 1.004 0.93 1.617 1.216 0.333 0.155 0.686 0.274 1.053 0.353 1.043 0.224 2.108 0.109 3.080-0.332s1.757-1.169 2.274-2.103c0.516-0.934 0.714-1.987 0.572-3.044l-0.857-6.372zM17.717 28.961c-1.236 0.562-2.668 0.254-3.563-0.766-1.064-1.213-2.364-2.177-3.801-2.848-1.436-0.67-3.010-1.045-4.622-1.081l-0.046-0.001c-1.338-0.049-2.473-0.942-2.833-2.236-0.363-1.308 0.164-2.674 1.31-3.401l5.432-3.439c1.712-1.084 3.829-1.22 5.665-0.364s3.093 2.566 3.363 4.574l0.857 6.372c0.181 1.346-0.528 2.628-1.763 3.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F9",
    style: {
      fill: "var(--color1, #FEF9F9)"
    },
    d: "M6.295 12.527c1.103 0.077 2.165-0.346 2.991-1.19 0.786-0.803 1.264-1.901 1.346-3.091s-0.241-2.342-0.909-3.246c-0.702-0.949-1.696-1.514-2.798-1.59-2.216-0.154-4.161 1.766-4.336 4.281-0.137 2.003 0.89 3.786 2.433 4.506 0.394 0.184 0.822 0.298 1.272 0.329zM4.461 7.821c0.103-1.482 1.151-2.621 2.336-2.539 0.214 0.015 0.422 0.069 0.618 0.161 0.302 0.141 0.576 0.369 0.8 0.673 0.403 0.546 0.597 1.257 0.546 2.002s-0.341 1.423-0.816 1.908c-0.435 0.444-0.975 0.668-1.52 0.63l-0.001 0c-1.184-0.081-2.064-1.353-1.963-2.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F9",
    style: {
      fill: "var(--color1, #FEF9F9)"
    },
    d: "M14.188 11.529c2.349 1.095 5.275-0.191 6.523-2.867s0.353-5.746-1.996-6.841c-2.349-1.095-5.275 0.191-6.523 2.868s-0.352 5.745 1.996 6.84zM17.923 3.521c1.411 0.658 1.9 2.609 1.089 4.348s-2.619 2.618-4.031 1.96-1.9-2.608-1.089-4.347c0.811-1.739 2.619-2.619 4.031-1.961z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F9",
    style: {
      fill: "var(--color1, #FEF9F9)"
    },
    d: "M20.992 16.152l0 0c0.305 0.288 0.647 0.518 1.014 0.689 1.713 0.799 3.964 0.33 5.495-1.289 0.881-0.932 1.401-2.109 1.463-3.315 0.065-1.262-0.371-2.404-1.23-3.217s-2.025-1.184-3.281-1.047c-1.201 0.131-2.347 0.716-3.227 1.648-1.858 1.966-1.963 4.896-0.234 6.531zM22.588 10.909c0.575-0.609 1.309-0.989 2.067-1.071 0.701-0.076 1.337 0.118 1.79 0.546s0.682 1.052 0.645 1.756c-0.039 0.761-0.378 1.516-0.953 2.124-1.148 1.215-2.878 1.45-3.857 0.525-0.978-0.925-0.84-2.665 0.308-3.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F9",
    style: {
      fill: "var(--color1, #FEF9F9)"
    },
    d: "M30.227 19.769l-0-0.001c-1.062-1.952-3.726-2.563-5.94-1.362-2.213 1.203-3.152 3.77-2.093 5.721 0.386 0.712 0.986 1.246 1.699 1.579 1.243 0.58 2.833 0.548 4.241-0.215 2.213-1.203 3.152-3.769 2.093-5.722zM27.239 23.842c-1.307 0.709-2.831 0.435-3.397-0.609-0.566-1.043 0.035-2.469 1.339-3.178 0.867-0.47 1.83-0.508 2.545-0.174 0.362 0.169 0.661 0.433 0.852 0.784 0.565 1.044-0.036 2.469-1.339 3.178z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pawprint-blue",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54ADFF",
    style: {
      fill: "var(--color1, #54ADFF)"
    },
    d: "M14.188 11.529c2.349 1.095 5.275-0.191 6.523-2.867s0.353-5.746-1.996-6.841c-2.349-1.095-5.275 0.191-6.523 2.868s-0.352 5.745 1.996 6.84zM17.923 3.521c1.411 0.658 1.9 2.609 1.089 4.348s-2.619 2.618-4.031 1.96-1.9-2.608-1.089-4.347c0.811-1.739 2.619-2.619 4.031-1.961z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54ADFF",
    style: {
      fill: "var(--color1, #54ADFF)"
    },
    d: "M20.992 16.152l0 0c0.305 0.288 0.647 0.518 1.014 0.689 1.713 0.799 3.964 0.33 5.495-1.289 0.881-0.932 1.401-2.109 1.463-3.315 0.065-1.262-0.371-2.404-1.23-3.217s-2.025-1.184-3.281-1.047c-1.201 0.131-2.347 0.716-3.227 1.648-1.858 1.966-1.963 4.896-0.234 6.531zM22.588 10.909c0.575-0.609 1.309-0.989 2.067-1.071 0.701-0.076 1.337 0.118 1.79 0.546s0.682 1.052 0.645 1.756c-0.039 0.761-0.378 1.516-0.953 2.124-1.148 1.215-2.878 1.45-3.857 0.525-0.978-0.925-0.84-2.665 0.308-3.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54ADFF",
    style: {
      fill: "var(--color1, #54ADFF)"
    },
    d: "M30.227 19.769l-0-0.001c-1.062-1.952-3.726-2.563-5.94-1.362-2.213 1.203-3.152 3.77-2.093 5.721 0.386 0.712 0.986 1.246 1.699 1.579 1.243 0.58 2.833 0.548 4.241-0.215 2.213-1.203 3.152-3.769 2.093-5.722zM27.239 23.842c-1.307 0.709-2.831 0.435-3.397-0.609-0.566-1.043 0.035-2.469 1.339-3.178 0.867-0.47 1.83-0.508 2.545-0.174 0.362 0.169 0.661 0.433 0.852 0.784 0.565 1.044-0.036 2.469-1.339 3.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54ADFF",
    style: {
      fill: "var(--color1, #54ADFF)"
    },
    d: "M6.295 12.527c1.103 0.077 2.165-0.346 2.991-1.19 0.786-0.803 1.264-1.901 1.346-3.091s-0.241-2.342-0.909-3.246c-0.702-0.949-1.696-1.514-2.798-1.59-2.216-0.154-4.161 1.766-4.336 4.281-0.137 2.003 0.89 3.786 2.433 4.506 0.394 0.184 0.822 0.298 1.272 0.329zM4.461 7.821c0.103-1.482 1.151-2.621 2.336-2.539 0.214 0.015 0.422 0.069 0.618 0.161 0.302 0.141 0.576 0.369 0.8 0.673 0.403 0.546 0.597 1.257 0.546 2.002s-0.341 1.423-0.816 1.908c-0.435 0.444-0.975 0.668-1.52 0.63l-0.001 0c-1.184-0.081-2.064-1.353-1.963-2.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54ADFF",
    style: {
      fill: "var(--color1, #54ADFF)"
    },
    d: "M20.482 19.149c-0.356-2.644-2.011-4.897-4.429-6.024s-5.208-0.948-7.462 0.479l-5.432 3.439c-0.901 0.571-1.58 1.399-1.964 2.394s-0.436 2.065-0.15 3.093c0.286 1.028 0.882 1.918 1.725 2.573s1.852 1.014 2.919 1.037l0.070 0.001c2.676 0.079 5.219 1.275 6.986 3.289 0.456 0.519 1.004 0.93 1.617 1.216 0.333 0.155 0.686 0.274 1.053 0.353 1.043 0.224 2.108 0.109 3.080-0.332s1.757-1.169 2.274-2.103c0.516-0.934 0.714-1.987 0.572-3.044l-0.857-6.372zM17.717 28.961c-1.236 0.562-2.668 0.254-3.563-0.766-1.064-1.213-2.364-2.177-3.801-2.848-1.436-0.67-3.010-1.045-4.622-1.081l-0.046-0.001c-1.338-0.049-2.473-0.942-2.833-2.236-0.363-1.308 0.164-2.674 1.31-3.401l5.432-3.439c1.712-1.084 3.829-1.22 5.665-0.364s3.093 2.566 3.363 4.574l0.857 6.372c0.181 1.346-0.528 2.628-1.763 3.19z"
  })), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 26.667v-10.667M16 16v-10.667M16 16h10.667M16 16h-10.667"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus-small",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M16 9.333v13.333M9.333 16h13.333"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-round",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M5.333 10.667c0-2.946 2.388-5.333 5.333-5.333h10.667c2.945 0 5.333 2.388 5.333 5.333v10.667c0 2.945-2.388 5.333-5.333 5.333h-10.667c-2.946 0-5.333-2.388-5.333-5.333v-10.667z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54adff",
    style: {
      fill: "var(--color1, #54adff)"
    },
    d: "M25.96 27.374c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-1.414 1.414zM23 14c0 4.971-4.029 9-9 9v2c6.075 0 11-4.925 11-11h-2zM14 23c-4.971 0-9-4.029-9-9h-2c0 6.075 4.925 11 11 11v-2zM5 14c0-4.971 4.029-9 9-9v-2c-6.075 0-11 4.925-11 11h2zM14 5c4.971 0 9 4.029 9 9h2c0-6.075-4.925-11-11-11v2zM27.374 25.96l-5.583-5.583-1.414 1.414 5.583 5.583 1.414-1.414z"
  })), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M24 8v16c0 1.473-1.194 2.667-2.667 2.667h-10.667c-1.473 0-2.667-1.194-2.667-2.667v-16M20 8v-1.333c0-1.473-1.194-2.667-2.667-2.667h-2.667c-1.473 0-2.667 1.194-2.667 2.667v1.333M5.333 8h21.333M13.333 13.333v8M18.667 13.333v8"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.7143,
    d: "M25.143 27.429v-2.286c0-2.525-2.047-4.571-4.571-4.571h-9.143c-2.525 0-4.571 2.047-4.571 4.571v2.286M20.571 11.429c0 2.525-2.047 4.571-4.571 4.571s-4.571-2.047-4.571-4.571c0-2.525 2.047-4.571 4.571-4.571s4.571 2.047 4.571 4.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.7143,
    d: "M16 0.857c8.363 0 15.143 6.78 15.143 15.143s-6.78 15.143-15.143 15.143c-8.363 0-15.143-6.78-15.143-15.143s6.78-15.143 15.143-15.143z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 73 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.65l8.198 10.583c0.713 0.903 2.020 1.032 2.97 0.258 0.832-0.774 0.95-2.194 0.238-3.227l-7.723-9.938h65.821c1.188 0 2.138-1.032 2.138-2.323s-0.95-2.323-2.138-2.323h-65.821l7.723-9.938c0.713-0.903 0.594-2.323-0.238-3.227-0.356-0.387-0.832-0.516-1.307-0.516-0.594 0-1.188 0.258-1.545 0.774l-8.198 10.583c-2.139 2.839-2.139 6.711-0.119 9.293z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 73 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.7143,
    d: "M70.174 12.487l0.006 0.007c0.52 0.665 0.863 1.463 1.015 2.316l-9.45-12.161c-0.090-0.144-0.129-0.318-0.117-0.482 0.010-0.131 0.049-0.215 0.081-0.262 0.077-0.046 0.138-0.050 0.172-0.047 0.041 0.004 0.072 0.018 0.103 0.056l8.19 10.573zM67.959 15.53h3.318c0.016 0.308 0.008 0.62-0.025 0.932h-69.114c-0.035 0-0.086-0.011-0.148-0.078-0.065-0.071-0.133-0.201-0.133-0.388s0.068-0.317 0.133-0.388c0.062-0.068 0.113-0.078 0.148-0.078h65.821zM69.426 19.459l1.68-2.161c-0.193 0.774-0.542 1.531-1.058 2.218l-8.228 10.623c-0.009 0.002-0.022 0.004-0.038 0.004-0.002 0-0.005 0-0.007-0-0.083-0.12-0.135-0.267-0.147-0.414-0.014-0.184 0.039-0.286 0.067-0.321l0.009-0.011 7.722-9.938z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.46703369d4c75eb004d1bc3b477343b9.svg";
export { ForwardRef as ReactComponent };